import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

type HeadFilterTextFieldProps = {
  filterValue: string;
  setFilterValue: (value: string) => void;
  selectedColumn: { label?: string; numericFilter?: boolean } | null;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function HeadFilterTextField({
  filterValue,
  setFilterValue,
  selectedColumn,
  t,
}: HeadFilterTextFieldProps) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      placeholder={`${t('FILTER')} ${selectedColumn?.label}`}
      value={filterValue}
      inputProps={selectedColumn?.numericFilter ? { inputMode: 'numeric' } : undefined}
      onChange={(e) => {
        const raw = selectedColumn?.numericFilter
          ? e.target.value.replace(/\D/g, '')
          : e.target.value;
        const newValue = raw.trim();
        if (newValue.length === 0) {
          setFilterValue('');
          return;
        }
        setFilterValue(raw);
      }}
    />
  );
}
